import { CreateOutlined, CollectionsOutlined } from "@mui/icons-material";

export const APP_VERSION = "1.0.00";
export const SIDEBAR_MENU_ITEMS = [
  { name: "create", icon: <CreateOutlined /> },
  { name: "orders", icon: <CollectionsOutlined /> },
];
